import { RouteConfig } from 'vue-router';

export class EditorRoute {
  static EDITOR_TEMPLATES: RouteConfig = {
    name: 'editor-dashboard',
    path: 'editor-dashboard'
  };

  static EDITOR_DOCUMENT: RouteConfig = {
    name: 'editor-document',
    path: '/editor/document/:id'
  };
}
